import {useCallback, useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import Api from "../../../helpers/api";
import {Button, ButtonGroup, LegacyCard} from "@shopify/polaris";

export const OnHoldToggle = ({ customer, setCustomer }) => {
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState({can_manage_on_hold: false, is_admin: false})
    const [hasOrders, setHasOrders] = useState(true);
    const history = useHistory();

    useEffect(() => {
        setLoading(true);

        Promise
            .all([

                Api.hasCustomerOrders(customer.id),
                Api.getMe()
            ])
            .then(results => {
                setHasOrders(results[0].data.status ?? false)
                setUser(results[1].data.user ?? {can_manage_on_hold: false, is_admin: false})
            })
            .finally(() => setLoading(false));
    }, [customer.id]);

    const toggleOnHold = useCallback(async () => {
        if (loading)
            return;

        setLoading(true);
        const response = await Api.toggleCustomerOnHold(customer.id);
        setCustomer(response.data.data);
        setLoading(false);
    }, [customer, loading]);

    const handleDelete = useCallback(() => {
        if (loading) {
            return;
        }

        setLoading(true);
        const confirmation = confirm("Are you sure you want to delete this customer?");

        if (confirmation) {
            Api.deleteCustomer(customer.id).then(() => {
                history.goBack();
                setLoading(false);
            });
        } else {
            setLoading(false);
        }
    }, [loading, customer]);

    return (
        <LegacyCard sectioned>
            <ButtonGroup>
                {!hasOrders && (
                    <Button variant="destructive" onClick={handleDelete} loading={loading}>
                        Delete customer
                    </Button>
                )}
                <Button variant="destructive" onClick={toggleOnHold} loading={loading} disabled={loading || (!user.can_manage_on_hold && !user.is_admin)}>
                    {customer?.is_on_hold ? 'Unset from hold' : 'Set on hold'}
                </Button>
            </ButtonGroup>
        </LegacyCard>
    )
}
